/**
 * Tiny Slider autoplay pause/play control (WCAG 2.2.2).
 */

export function prefersReducedMotion() {
	return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Whether tns autoplay should start on.
 *
 * @returns {boolean}
 */
export function shouldAutoplaySlider() {
	return !prefersReducedMotion();
}

/**
 * Wire a pause/play toggle button to a tiny-slider instance.
 *
 * @param {Object} slider tns instance
 * @param {HTMLElement|null} button
 */
export function wireTnsAutoplayToggle(slider, button) {
	if (!slider || !button || typeof slider.pause !== 'function' || typeof slider.play !== 'function') {
		return;
	}

	const pauseLabel = button.getAttribute('data-label-pause') || 'Pause slideshow';
	const playLabel = button.getAttribute('data-label-play') || 'Play slideshow';
	const pauseIcon = button.querySelector('.slider-autoplay-toggle__icon--pause');
	const playIcon = button.querySelector('.slider-autoplay-toggle__icon--play');

	let isPlaying = shouldAutoplaySlider();

	const syncUi = () => {
		const label = isPlaying ? pauseLabel : playLabel;

		// Playing → pause icon; paused → play icon.
		button.setAttribute('aria-pressed', isPlaying ? 'false' : 'true');
		button.setAttribute('aria-label', label);
		button.setAttribute('data-tooltip', label);
		button.classList.toggle('is-paused', !isPlaying);

		if (pauseIcon) {
			pauseIcon.hidden = !isPlaying;
		}

		if (playIcon) {
			playIcon.hidden = isPlaying;
		}
	};

	if (!isPlaying) {
		slider.pause();
	}

	button.addEventListener('click', () => {
		if (isPlaying) {
			slider.pause();
			isPlaying = false;
		} else {
			slider.play();
			isPlaying = true;
		}

		syncUi();
	});

	syncUi();
}
